import { path } from 'ramda';

import { FEATURE_NAME as $, LIST, FILTERS } from './consts';

export const getCountries = path([$, LIST]);
export const getCountry = path([$, LIST, 0]);
export const geyCountryProp = (name) => path([$, LIST, 0, name]);
export const getCountriesFilters = path([$, FILTERS]);
